import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
/** Using Helmet to secure our page meta tags */
const MetaTags = () => (
  <HelmetProvider>
    <Helmet>
        <meta http-equiv="Cache-Control" content="no-store, no-cache, must-revalidate, max-age=0"/>
        <meta http-equiv="Pragma" content="no-cache"/>
        <meta http-equiv="Expires" content="0"/>

        <meta charset="UTF-8"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0 "/>
        <meta name="google" content="notranslate"/>
        <meta http-equiv="X-UA-Compatible" content="ie=edge"/>
        <title>Reclamation qualité</title>
        <link rel="icon" href="assets/images/app-icon.png"/>
    </Helmet>
  </HelmetProvider>
);

export default MetaTags;